<script setup lang="ts">
import SimpleBar from "simplebar";
import { locale } from "../../locale";
import { sortedUserList, usersState } from "../../states/usersState";
import UserItemRightMenu from "../UserItemRightMenu.vue";
import { ref, watch, watchEffect } from "vue";
import { roomState } from "../../states/room";
import { approveUserAll, rejectUserAll, usersInWaitRoom } from "../../states/waitRoomState";
import UserInWaitRoom from "../UserInWaitRoom.vue";
import RejectAll from "./RejectAll.vue";
import ApproveAll from "./ApproveAll.vue";

const scroll = ref<HTMLElement | null>(null);
let smpbar: SimpleBar | null = null;
watchEffect(() => {
  if (scroll.value) {
    smpbar = new SimpleBar(scroll.value, { autoHide: false });
  }
});
watch(
  () => usersState.users.length,
  () => {
    if (smpbar) smpbar.recalculate();
  },
);
</script>
<template>
  <div class="user-list">
    <div class="user-list-block">
      <div ref="scroll" class="scroll">
        <div v-if="roomState.waitRoom && usersInWaitRoom.length" class="wait-label"><span>{{ locale.waitRoom.label.toUpperCase() }}{{ usersInWaitRoom.length }}</span></div>
        <UserInWaitRoom v-for="user in usersInWaitRoom" :user="user" />
        <div v-if="roomState.waitRoom && usersInWaitRoom.length" class="controls">
          <RejectAll @click="rejectUserAll" />
          <ApproveAll @click="approveUserAll" />
        </div>
        <div class="users-label"><span>{{ locale.usersLabel.toUpperCase() }}{{ usersState.users.length }}</span></div>
        <UserItemRightMenu v-for="user in sortedUserList" :user="user" />
        <div class="spacer-bottom"></div>
      </div>
      <div class="gradient"></div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.user-list {
  width: 100%;
  height: 100%;
  background-color: #1e1818;
  display: flex;
  flex-direction: column;
}

.wait-label, .users-label {
  width: 100%;
  height: 35px;
  background-color: rgba(39, 34, 34, 1);
  font-family: Open Sans;
  font-size: 13px;
  font-weight: 400;
  line-height: 17.7px;
  text-align: center;
  color: rgba(216, 216, 216, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.title {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(73, 73, 73, 0.48);
  color: #f6f6f6;
}

.title .text {
  font: Open Sans;
  font-size: 14px;
  font-weight: 600;
}

.user-list-block {
  position: relative;
  height: 100%;
  flex-grow: 1;
  width: 100%;
  padding-top: 12px;
  display: flex;
  flex-direction: column;
}

.scroll {
  width: 100%;
  height: 300px;
  flex-grow: 1;
}

.gradient {
  height: 48px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  pointer-events: none;
  background: linear-gradient(180deg, rgba(30, 24, 24, 0) 0%, #1e1818 100%);
}

.spacer-bottom {
  width: 100%;
  min-height: 24px;
}

.controls {
  display: flex;
  gap: 10px;
  padding: 4px 12px 8px 12px;
  justify-content: right;
}
</style>
<style>
.user-list .user-list-block .simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  background: rgba(116, 116, 116, 0.85);
  width: 4px;
}
</style>
